import styled from "styled-components/macro";
import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  background: ${theme.colors.bgSecondary};
  & > div {
    margin: 0 auto;
    max-width: 1380px;
    padding: 46px 120px;
    display: flex;
    justify-content: space-between;
    color: ${theme.colors.text};
    @media (max-width: 930px) {
      padding: 46px 40px;
    }
    @media (max-width: 850px) {
      padding: 46px 20px;
    }
    @media (max-width: 768px) {
      flex-direction: column-reverse;
      & img {
        margin-bottom: 20px;
      }
      & button {
        width: 100%;
      }
    }
  }
`;

export const Content = styled.div`
  max-width: 530px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-right: 20px;
  & > div {
    font-size: 32px;
    margin-bottom: 32px;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    & > div {
      font-size: 24px;
      margin-bottom: 18px;
    }
  }
`;

export const ImgSection = styled.div`
  & img {
    border-radius: 6px;
    width: 99%;
    object-fit: cover;
    height: 330px;
  }
`;
